import { render } from "./WaTest.vue?vue&type=template&id=62886e90"
import script from "./WaTest.vue?vue&type=script&lang=js"
export * from "./WaTest.vue?vue&type=script&lang=js"

import exportComponent from "/home/adminhost/web/crevent.waroengss.id/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__